import { useContext } from 'react';
import Responsive from '@/context/responsive.context';

export function useResponsive() {
    const { ...media } = useContext(Responsive);
    return media;
}
